import {
    createApp,
    defineAsyncComponent
} from 'vue';

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
import CookiesMsg from './plugins/cookies-msg/index.js';
import SiteDrawer from './plugins/site-drawer/index.js';

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
import BgImage from './components/bg-image/index.vue';
import BgVideo from './components/bg-video/index.vue';
const CountOnView = defineAsyncComponent(() => import('./components/count-on-view/index.vue'));
const PressReleases = defineAsyncComponent(() => import('./press-releases.vue'));
const FleetTable = defineAsyncComponent(() => import('./fleet-table.vue'));
const NewsletterForm = defineAsyncComponent(() => import('./newsletter-form.vue'));
const ContactForm = defineAsyncComponent(() => import('./contact-form.vue'));
// const GoogleMap = defineAsyncComponent(() => import('./components/google-map/index.vue'))

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES


/////////////////////////////////////////////////////////////////////////////////////////////////// APP
import bsModal from 'bootstrap/js/dist/modal';
import bsCollapse from "bootstrap/js/dist/collapse.js";
import Animations from './animations.js';

import {
    devices,
    viewportSize
} from './imports/utils';

createApp({
    mixins: [Animations],
    components: {
        CountOnView,
        PressReleases,
        FleetTable,
        NewsletterForm,
        ContactForm
    },
    data() {
        return {
            isDevice: devices(),
            viewportSize: viewportSize(),
            scrollTop: window.scrollY,
            mobileMenuOpen: false,
            bsCollapse: null,
            collapseShown: viewportSize().width > 991 ? 'corporate-governance-0' : null
        }
    },
    methods: {
        onMobileMenuOpen() {
            this.mobileMenuOpen = true;
        },
        onMobileMenuClose() {
            this.mobileMenuOpen = false;
        },
        onResize() {
            this.viewportSize = viewportSize();
        },
        onScroll() {
            this.scrollTop = window.scrollY;
        },
        showModal(id) {
            new bsModal(`#${id}`, {
                backdrop: 'static',
                focus: true
            }).show();
        },
        // hideModal(id) {
        //     new bsModal(`#${id}`).hide();
        // },
        showCollapse(id) {
            this.bsCollapse = new bsCollapse(`#${id}`, {
                toggle: false
            });

            this.bsCollapse.show();

            const myCollapsible = document.getElementById(id);

            myCollapsible.addEventListener('shown.bs.collapse', event => {
                this.toElement(id);
            });

            this.collapseShown = id;
        },
        hideCollapse(id) {
            this.bsCollapse.hide();
            this.bsCollapse = null;
            this.collapseShown = null;
        },
        toggleCollapse(id) {
            new bsCollapse(`#${id}`, {
                toggle: true
            }).show();

            if (this.collapseShown === id) {
                this.collapseShown = null;
            } else {
                this.collapseShown = id;
            }
        },
        toElement(id) {
            const top = document.getElementById(id).offsetTop;

            window.scrollTo({
                top: top - 200,
                behavior: 'smooth'
            });
        },
    },
    created() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');

        window.addEventListener("resize", this.onResize, {
            passive: true
        });

        window.addEventListener("scroll", this.onScroll, {
            passive: true
        });
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize);
        window.removeEventListener("scroll", this.onScroll);
    }
})
    .use(CookiesMsg)
    .use(SiteDrawer)
    .component('BgImage', BgImage)
    .component('BgVideo', BgVideo)
    .mount('#app');